"use client"

import { Skeleton } from "@/components/ui/skeleton"

const StoreMapSkeleton = () => {
    return (
        <div className="w-full sm:w-[72.5%] border border-[#00000033] border-l-0 h-[400px] sm:h-full relative bg-gray-100">
            {/* Map Area Skeleton */}
            <Skeleton className="w-full h-full rounded-none" />

            {/* Map Controls Skeleton */}
            <div className="absolute top-4 left-4 flex gap-2">
                <Skeleton className="h-8 w-16 rounded" />
                <Skeleton className="h-8 w-20 rounded" />
            </div>

            <div className="absolute top-4 right-4">
                <Skeleton className="h-8 w-8 rounded" />
            </div>

            <div className="absolute bottom-4 right-4 flex flex-col gap-2">
                <Skeleton className="h-8 w-8 rounded" />
                <Skeleton className="h-8 w-8 rounded" />
            </div>
        </div>
    )
}

export default StoreMapSkeleton
